import React, { useEffect } from 'react';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { EmotionalClose } from './components/EmotionalClose';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
type AppProps = {
  showUrgencyBanner?: boolean;
  showSocialProofToast?: boolean;
};
export function App({
  showUrgencyBanner = true,
  showSocialProofToast = true
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: 'FENG SHUI NEGOCIOS™',
      content_type: 'product',
      value: 24990,
      currency: 'ARS'
    });
  }, []);
  return <div className="min-h-screen w-full bg-brand-rice font-sans text-brand-ink selection:bg-brand-jadeMist selection:text-brand-jadeDeep" data-id="element-0" data-mp="3mkhofzsx1e8o">
      {showUrgencyBanner && <UrgencyBanner data-id="element-1" data-mp="5otf64sd496" />}
      <main data-id="element-2" data-mp="680frswe88f">
        <Hero data-id="element-3" data-mp="4n53zyrel9i" />
        <PackContents data-id="element-4" data-mp="5gbgztt38r4" />
        <InitialTestimonials data-id="element-5" data-mp="7ssnarqpf34" />
        <PainPoints data-id="element-6" data-mp="2zllcouynw8jk" />
        <LaunchOffer data-id="element-7" data-mp="2zm4vedw4z0yn" />
        <MoreTestimonials data-id="element-8" data-mp="2zmwit1fkxsdu" />
        <FAQ data-id="element-9" data-mp="33mov9p83gioh" />
        <CostComparison data-id="element-10" data-mp="33mf623uvifju" />
        <EmotionalClose data-id="element-11" data-mp="33nq4do5juv3k" />
      </main>
      <Footer data-id="element-12" data-mp="33orjq4tlm3r3" />
      {showSocialProofToast && <FloatingNotification data-id="element-13" data-mp="38l8h7pmotugu" />}
    </div>;
}